module.exports = __webpack_public_path__ + "faa8209e2e9ce9ce21e1de7fb47d9288.png";